const logzTestPrefix = 'data-logz-test-';
const logzTestAttribute = attr => `${logzTestPrefix}${attr}`;
export const generateLogzTestAttributes = (attributeList) => {
    const testAttributes = {};
    Object.entries(attributeList)
        .filter(attrVal => attrVal)
        .forEach(([attrKey, attrVal]) => {
        if (typeof attrVal === 'function') {
            testAttributes[logzTestAttribute(attrKey)] = attrVal;
        }
        else if (attrVal) {
            testAttributes[logzTestAttribute(attrKey)] = String(attrVal);
        }
    });
    return testAttributes;
};
export const testContextOperator = {
    Equal: '=',
    Contains: '*=',
    Starts: '^=',
};
export const buildTestAttribute = attrName => `${logzTestPrefix}${attrName}`;
export const buildTestAttributeSelector = (attrName, value, operator = testContextOperator.Equal) => `[${buildTestAttribute(attrName)}${operator}'${value}']`;
//# sourceMappingURL=logzTestGenerator.js.map